import { Component, ViewChild } from '@angular/core';
import { iBisViewComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { EditPackageService } from './edit-package.service';
@Component({
    selector: 'app-package',
    templateUrl: './package.component.html'
})
export class PackageComponent extends iBisViewComponent {
    @ViewChild('gridPackage') declare grid: DxDataGridComponent;

    public declare edit: EditPackageService;
    constructor(public proxy: ProxyService) {
        super(proxy.packages, proxy.lg, proxy.iui, proxy.activatedRoute);
        this.key = '[MDS]Package';
    }

    onPackageExpanding(event: any) {
        event.component.collapseAll(-1);
    }
}
